import { Box, SvgIcon, Typography } from "@mui/material";

type IProps = {
	message?: string;
};
const NoDataFound = ({ message = "No Data Found" }: IProps) => {
	return (
		<Box
			display='flex'
			flexDirection='column'
			justifyContent='center'
			alignItems='center'
			height='100%'
			textAlign='center'
			p={4}
		>
			<SvgIcon viewBox='0 0 64 64' fontSize='large' color='action'>
				<circle
					cx='32'
					cy='32'
					r='30'
					stroke='currentColor'
					strokeWidth='4'
					fill='none'
				/>
				<line
					x1='20'
					y1='32'
					x2='44'
					y2='32'
					stroke='currentColor'
					strokeWidth='4'
				/>
			</SvgIcon>
			{/* Replace this with an appropriate image/icon */}
			<Typography variant='h6' color='text.secondary' mt={2}>
				{message}
			</Typography>
		</Box>
	);
};

export default NoDataFound;
